import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Modal from '@material-ui/core/Modal';
import FormControl from '@material-ui/core/FormControl';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import Alert from '@material-ui/lab/Alert';
import isEmpty from 'lodash/isEmpty';
import { injectIntl } from 'react-intl';

import { ADGMModal, ADGMImage } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import messages from 'aurora-translations';
import PropertyBadge from '../ADGMPropertiesV2/PropertyList/Badge';

import RejectReturnAlertBox from '../RejectReturnAlertBox';

import stylesReturnHeader from './stylesReturnHeader';

// eslint-disable-next-line react/prop-types

function ReturnHeader(props) {
  const {
    classes,
    property,
    status,
    failure,
    intl,
    locale,
    handleSubmit,
    handleSubmitCancelApplication,
    IsCanTerminate,
    IsCanReturn,
    applicationType,
    applicationNumber,
    showApplicationHeader,
    ReasonNotes,
    alertTitle,
    showEditBtnInAlert,
    RejectFeedpackPopup,
  } = props;
  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);
  const [isModalOpenReject, setModalOpenReject] = useState(false);
  const [isModalOpenRejectFeedback, setModalOpenRejectFeedback] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [inputValRejectFeedback, setInputValRejectFeedback] = useState('');
  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };

  const toggleModalReject = () => {
    setModalOpenReject(!isModalOpenReject);
  };
  const toggleModalRejectFeedBack = () => {
    setModalOpenRejectFeedback(!isModalOpenRejectFeedback);
  };

  const goToMakerEdit = () => {
    const req = {
      rejection: '',
      approval: true,
    };
    handleSubmit(req);
  };

  const inputHandler = event => {
    setInputVal(event.target.value);
  };

  const inputHandlerRejectFeedback = event => {
    setInputValRejectFeedback(event.target.value);
  };

  const submitRejection = () => {
    const req = {
      rejection: inputVal,
      approval: false,
    };
    handleSubmit(req);
  };

  const submitRejectionRejectFeedback = () => {
    const req = {
      rejection: inputValRejectFeedback,
      approval: false,
    };
    handleSubmit(req, true);
  };
  const UNIT = property?.propertyType === 4;
  const PLOT = property?.propertyType === 1;
  const ImageSrc = PLOT ? 'land_property.svg' : 'PropertyDetails-Unit.svg';
  const propertiesKeysMap = {
    ar: {
      community: 'communityAr',
      district: 'districtAr',
      plotNumber: 'plotNumber',
      unitNumber: 'unitNumber',
      buildingNumber: 'buildingNumber',
    },
    en: {
      community: 'communityEn',
      district: 'districtEn',
      plotNumber: 'plotNumber',
      unitNumber: 'unitNumber',
      buildingNumber: 'buildingNumber',
    },
  };
  const { community, district, plotNumber, unitNumber, buildingNumber } = propertiesKeysMap[locale];
  return (
    <>
      {failure?.statusCode && (
        <Alert severity='error' className={classes.errorMessage}>
          {keyEmptyCheck(failure?.message)}
        </Alert>
      )}

      <Grid container spacing={3} alignItems='center'>
        {!showApplicationHeader && (
          <Grid item xs={12} md={6} className={classes.headerContainer}>
            <Grid className={classes.propertyDetailsContainer}>
              <Grid item className={classes.imgCls}>
                <ADGMImage name={ImageSrc} alt={ImageSrc} className={classes.headerImage} />
              </Grid>
              <Grid item>
                <Typography variant='h6' className={classes.title}>
                  {UNIT ? (
                    <span>
                      {keyEmptyCheck('Unit')} {property?.[unitNumber]}, {keyEmptyCheck('building')}{' '}
                      {property?.[buildingNumber]}{' '}
                    </span>
                  ) : (
                    <span>
                      {keyEmptyCheck('Plot')} {property?.[plotNumber]}
                    </span>
                  )}
                  <div className={classes.chip}>{keyEmptyCheck(PLOT ? 'Plot' : 'Unit')}</div>
                </Typography>

                <Typography variant='h6' className={classes.subInfo}>
                  {property?.[community]}, {property?.[district]}
                </Typography>
                <Typography variant='h6' className={classes.badgeContainer}>
                  <PropertyBadge
                    locale={locale}
                    property={property}
                    isOwnership={false}
                    isLease
                    expanded={false}
                    handleExpand={() => {}}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {showApplicationHeader && (
          <Grid item xs={12} md={6}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {keyEmptyCheck(applicationType)}
            </Typography>
            <Typography variant='body1' className={classes.subTitle}>
              {keyEmptyCheck('Application_ID')}
              {': '}
              {applicationNumber}
            </Typography>
          </Grid>
        )}
        {IsCanTerminate ? (
          <Grid item xs={12} md={6} align='right' className={classes.rejectAcceptBtnHolder}>
            <Hidden smDown>
              <Button
                variant='outlined'
                className={classNames(classes.btns, classes.TerminateBtn)}
                size='large'
                onClick={toggleModalApplicationReject}
              >
                <ADGMImage name='cancelButtonIcon.svg' alt='crossicon' aria-hidden='true' />
                {keyEmptyCheck('cancel_application')}
              </Button>
            </Hidden>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.accptBtn)}
              size='large'
              onClick={goToMakerEdit}
            >
              {keyEmptyCheck('edit_application')}
            </Button>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} md={6} align='right' className={classes.rejectAcceptBtnHolder}>
              {IsCanReturn && (
                <Hidden smDown>
                  <Button
                    variant='outlined'
                    className={classNames(classes.btns, classes.rejectBtn)}
                    size='large'
                    onClick={toggleModalReject}
                  >
                    {keyEmptyCheck('return')}
                  </Button>
                </Hidden>
              )}
              <Button
                variant='contained'
                className={classNames(classes.btns, classes.accptBtn)}
                size='large'
                onClick={goToMakerEdit}
              >
                {keyEmptyCheck('edit_application')}
              </Button>
            </Grid>
            {typeof handleSubmitCancelApplication === 'function' && (
              <Hidden smDown>
                <Grid item xs={12} align='right'>
                  <Button
                    variant='text'
                    className={classNames(classes.rejectApplicationbtn)}
                    onClick={RejectFeedpackPopup ? toggleModalRejectFeedBack : toggleModalApplicationReject}
                  >
                    <CancelRoundedIcon />
                    {keyEmptyCheck('reject_application')}
                  </Button>
                </Grid>
              </Hidden>
            )}
          </>
        )}

        {!isEmpty(ReasonNotes) && (
          <Grid item xs={12}>
            <RejectReturnAlertBox
              isReject={false}
              reasons={Array.isArray(ReasonNotes) ? ReasonNotes : [ReasonNotes]}
              alertTitle={alertTitle}
              {...(showEditBtnInAlert && { editHandler: handleSubmit })}
            />
          </Grid>
        )}
      </Grid>

      <ADGMModal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenApplicationReject}
        toggleModal={toggleModalApplicationReject}
        onClose={toggleModalApplicationReject}
      >
        <div className={classes.innerModalAccept}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            aria-hidden='true'
            onClick={toggleModalApplicationReject}
          />
          <Typography variant='h6' component='h1' className={classes.Title}>
            {status && status === 'CHECKER_RETURN'
              ? keyEmptyCheck('reject_application')
              : keyEmptyCheck('termination_title')}
          </Typography>
          <Typography variant='h6' component='h2' className={classes.subTitle}>
            {keyEmptyCheck('this_will_terminate_the_application')}
          </Typography>
          <div className={classes.modalBtnholder}>
            <Button
              variant='outlined'
              className={classNames(classes.btns, classes.TerminateBtn)}
              size='large'
              onClick={toggleModalApplicationReject}
            >
              {keyEmptyCheck('cancel')}
            </Button>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.modalAccptBtn)}
              size='large'
              onClick={() => handleSubmitCancelApplication(IsCanTerminate ? 'DISCARD' : 'REJECT')}
            >
              {IsCanTerminate ? keyEmptyCheck('terminate') : keyEmptyCheck('reject')}
            </Button>
          </div>
        </div>
      </ADGMModal>
      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenReject}
        toggleModal={toggleModalReject}
        onClose={toggleModalReject}
      >
        <div className={classNames(classes.modal, classes.modalpaper)}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            onClick={toggleModalReject}
            aria-hidden='true'
          />
          <div className={classes.modaltitlehead}>
            <ADGMImage
              name='BackClose.svg'
              alt='BackClose'
              className={classes.mobilebackarrow}
              onClick={toggleModalReject}
              aria-hidden='true'
            />
          </div>
          <Typography variant='h6' component='h1' className={classes.tenantRejectTitle}>
            {keyEmptyCheck('return_reason')}
          </Typography>
          <FormControl className={classes.formControl}>
            <div htmlFor='PropertyID' className={classes.unitinputControl}>
              <TextareaAutosize
                aria-label='minimum height'
                minRows={1}
                placeholder={intl.formatMessage({
                  ...messages.return_reason,
                })}
                onChange={inputHandler}
                value={inputVal}
              />
              <p>{keyEmptyCheck('the_maximum_character_count_is', { s: 500 })}</p>
            </div>
          </FormControl>
          <div className={classNames(classes.modalBtnholder, classes.feedbackmodalBtnholder)}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.submitBtn)}
              size='large'
              onClick={submitRejection}
              disabled={!inputVal}
            >
              {keyEmptyCheck('submit_rejection')}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={isModalOpenRejectFeedback}
        toggleModal={toggleModalRejectFeedBack}
        onClose={toggleModalRejectFeedBack}
      >
        <div className={classNames(classes.modal, classes.modalpaper)}>
          <ADGMImage
            name='cross.svg'
            alt='crossicon'
            className={classes.crossIconimg}
            onClick={toggleModalRejectFeedBack}
            aria-hidden='true'
          />
          <div className={classes.modaltitlehead}>
            <ADGMImage
              name='BackClose.svg'
              alt='BackClose'
              className={classes.mobilebackarrow}
              onClick={toggleModalRejectFeedBack}
              aria-hidden='true'
            />
          </div>
          <Typography variant='h6' component='h1' className={classes.tenantRejectTitle}>
            {keyEmptyCheck('enter_reason_for_reject_new')}
          </Typography>
          <FormControl className={classes.formControl}>
            <div htmlFor='PropertyID' className={classes.unitinputControl}>
              <TextareaAutosize
                aria-label='minimum height'
                minRows={1}
                placeholder={intl.formatMessage({
                  ...messages.enter_reason_for_reject_new,
                })}
                onChange={inputHandlerRejectFeedback}
                value={inputValRejectFeedback}
              />
              <p>{keyEmptyCheck('rejection_feedback_text')}</p>
            </div>
          </FormControl>
          <div className={classNames(classes.modalBtnholder, classes.feedbackmodalBtnholder)}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.submitBtn)}
              size='large'
              onClick={submitRejectionRejectFeedback}
              disabled={!inputValRejectFeedback}
            >
              {keyEmptyCheck('submit_rejection')}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

ReturnHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  property: PropTypes.object,
  failure: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleSubmitCancelApplication: PropTypes.func.isRequired,
  IsCanTerminate: PropTypes.bool.isRequired,
  IsCanReturn: PropTypes.bool,
  applicationType: PropTypes.string,
  applicationNumber: PropTypes.string,
  showApplicationHeader: PropTypes.bool,
  RejectFeedpackPopup: PropTypes.bool,
  ReasonNotes: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  alertTitle: PropTypes.string,
  showEditBtnInAlert: PropTypes.bool,
};

ReturnHeader.defaultProps = {
  applicationType: '',
  applicationNumber: '',
  showApplicationHeader: false,
  property: {},
  IsCanReturn: true,
  ReasonNotes: '',
  alertTitle: '',
  showEditBtnInAlert: false,
  RejectFeedpackPopup: false,
};

export default withStyles(stylesReturnHeader)(injectIntl(ReturnHeader));
